import ReactDOM from "react-dom";
import { useWishlist } from "../../Context/WishlistContext"

const DeletePromptForCart = ({ showModal, onDelete, onCancel,data }) => {
  const { wishlist: wishlistItems, addToWishlist, removeFromWishlist } = useWishlist();

  if (!showModal) return null;

  let isWishlisted = false;

  if(data) {
     isWishlisted = wishlistItems.some(w => w.product_id === data.product_id && w.variant_id === data.variant_id);
  }
  return ReactDOM.createPortal(
    <div className="fixed inset-0 flex items-center justify-center bg-gray-300 bg-opacity-50 z-50 font-poppins">
      <div className="bg-white p-6 rounded-lg shadow-lg w-96">
        <h2 className="text-lg font-semibold">Are you sure you want to delete this item?</h2>

          {data && (
          <div className="flex items-center space-x-4 border p-3 rounded-md mb-4">
            <img
              src={data.image}
              alt={data.name}
              className="w-16 h-16 object-contain rounded"
            />
            <div className="flex flex-col">
              <p className="font-semibold text-gray-800">{data.name}</p>
              <p className="text-sm text-gray-500">
                By {data.manufacturer} • Pack: {data.pack_size}
              </p>
              <p className="text-sm text-gray-700">
                Price:{" "}
                {data.price !== data.discounted_price ? (
                  <>
                    <span className="line-through">₹{data.price}</span>{" "}
                    <span className="text-red-500 font-bold">
                      ₹{data.discounted_price}
                    </span>{" "}
                    ({data.discount_percent}% OFF)
                  </>
                ) : (
                  <span className="font-bold">₹{data.discounted_price}</span>
                )}
              </p>
              <p className="text-sm text-gray-600">
                Quantity: {data.quantity}
              </p>
            </div>
          </div>
        )}
 
          <div className="mt-4 flex justify-end space-x-4">

       { data && (               <button
              onClick={() => {
                if (isWishlisted) {
                  removeFromWishlist(data.product_id, data.variant_id);
                } else {
                  addToWishlist(data, data);
                }
              }}
              className={`px-4 py-2 text-sm rounded transition-colors duration-200
                ${isWishlisted 
                  ? "bg-red-500 hover:bg-red-600 text-white" 
                  : "bg-green-500 hover:bg-green-600 text-white"
                }`}
            >
            {isWishlisted ? "Remove from Wishlist" : "Move to Wishlist"}
            </button>   )         }
          <button
            onClick={onCancel}
            className="px-4 py-2 bg-gray-400 text-white rounded hover:bg-gray-500"
          >
            Cancel
          </button>
          <button
            onClick={onDelete}
            className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
          >
            Delete
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default DeletePromptForCart;
